import { infoBarPrefs, type InfoBarPrefs } from '@omnia/shared';

export const defaultPrefs = (): InfoBarPrefs => infoBarPrefs.parse({});

/** Anything unreadable falls back to defaults field by field, never to a broken bar. */
export function parsePrefs(raw: unknown): InfoBarPrefs {
  const result = infoBarPrefs.safeParse(raw ?? {});
  return result.success ? result.data : defaultPrefs();
}

export function serializePrefs(prefs: InfoBarPrefs): string {
  return JSON.stringify(prefs);
}

export function deserializePrefs(text: string | null): InfoBarPrefs {
  if (text === null) return defaultPrefs();
  try {
    return parsePrefs(JSON.parse(text));
  } catch {
    return defaultPrefs();
  }
}
